"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const main_service_1 = require("../../../main/main.service");
const index_1 = require("rxjs/index");
const _4d_mapper_1 = require("4d-mapper");
const operators_1 = require("rxjs/operators");
const Constants_1 = require("../../Constants");
class UploadToProjectComponent {
    constructor(dialogRef, mainService, fourD) {
        this.dialogRef = dialogRef;
        this.mainService = mainService;
        this.fourD = fourD;
        this.debug = Constants_1.Constants.debug_off;
        this.addToExisting = 'existing';
        this.newOne = 'newOne';
        this.existing = 'existing';
        this.newProjectName = '';
        this.projects = [];
        this.scenes = [];
    }
    ngOnInit() {
        if (this.debug) {
            console.log('upload-to-project.comp (loadProject)');
        }
        this.loadProject().subscribe();
    }
    loadProject() {
        if (this.debug) {
            console.log('upload-to-project.comp loadProject()');
        }
        if (!this.fourD.projects)
            return this.fourD.onReady().pipe(operators_1.flatMap(p => this.fourD.setActiveTeam(p[0].uid)), operators_1.flatMap(_ => this.loadProject()));
        this.projects = this.fourD.projects;
        return index_1.of('');
    }
    loadScene() {
        Constants_1.Constants.showHangOn();
        this.fourD.V.searchByObject(_4d_mapper_1.TransformGroup).equals('project', this.project.id).queryObservable().subscribe(value => {
            this.scenes = value.items;
            Constants_1.Constants.hideHangOn();
        });
    }
    ok() {
        if (this.addToExisting === this.newOne) {
            this.createNewProject();
        }
        else {
            this.dialogRef.close({
                project: this.project,
                scene: this.scene
            });
        }
    }
    createNewProject() {
        Constants_1.Constants.showHangOn();
        var p = new _4d_mapper_1.Project(this.fourD.V);
        p.name = this.newProjectName;
        p.account = this.fourD.activeTeam;
        p['ignoreOrientation'] = true;
        p.saveObservable().subscribe(savedProject => {
            savedProject.groupList().subscribe(fetchedTGs => {
                if (fetchedTGs) {
                    Constants_1.Constants.hideHangOn();
                    this.mainService.newProjectCreatedSubject.next(savedProject);
                    this.dialogRef.close({
                        project: savedProject,
                        scene: fetchedTGs[0]
                    });
                }
            });
        }, error1 => {
            console.log(error1);
            Constants_1.Constants.hideHangOn();
        });
    }
}
exports.UploadToProjectComponent = UploadToProjectComponent;
